import { SupabaseService } from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";

export type AccountPersonField = Database["public"]["Tables"]["account_person_field"]["Row"];

export class SupabaseAccountPersonFieldService extends SupabaseService<"account_person_field"> {
  table = "account_person_field" as const;
}
